module.exports = __webpack_public_path__ + "img/noresume.5a5db348.svg";